module.exports = "/legacy/3f1c2655634ca7c893049ee1e706461b.svg";